<template>
  <div
    class="d-flex text--disabled justify-center align-center gap-1 pt-1 px-3 pr-1 unselectable"
  >
    <small class="lh-1 text-12 text-truncate font-weight-medium"> {{ party?.name || "Carregando..." }} </small>
    <v-spacer />
    <small class="lh-1 text-12">
      {{ tabs.find((tab) => tab.id === type)?.name }}
    </small>
    <span class="pl-1">|</span>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          text
          class="text--disabled px-2"
          style="text-transform: none"
        >
          Ir para
          <v-icon small class="ml-1">mdi-chevron-right</v-icon>
        </v-btn>
      </template>
      <v-card class="d-flex flex-column pa-1 rounded-lg">
        <v-btn
          small
          text
          class="justify-start"
          v-for="tab in filteredTabs"
          :key="tab.id"
          :to="{
            name: tab.to,
            params: { partyId: party?.id },
          }"
        >
          <v-icon left>{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-btn>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    party: {
      type: Object | null,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    tabs: [
      {
        id: "details",
        name: "Detalhes",
        icon: "mdi-eye",
        to: "admin.party.details",
        permission: [2],
      },
      {
        id: "management",
        name: "Operacional",
        icon: "mdi-cog",
        to: "admin.party.management",
        permission: [16, 64, 128, 512, 8192, 524288, 131072, 524288],
      },
      // {
      //   id: "financial",
      //   name: "Financeiro",
      //   icon: "mdi-cash-multiple",
      //   to: "admin.party.financial",
      //   permission: [2048, 4096],
      // },
      {
        id: "reports",
        name: "Relatórios",
        icon: "mdi-chart-line",
        to: "admin.party.reports",
        permission: [512, 2048, 536870912],
      },
      {
        id: "entrance",
        name: "Entrada",
        icon: "mdi-qrcode",
        to: "admin.entrance.management",
        permission: [131072],
      },
    ],
  }),
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    filteredTabs() {
      return this.tabs.filter(
        (tab) => tab.id !== this.type && this.hasPermission(tab.permission)
      );
    },
  },
};
</script>
